import { Scale } from "../../utils/Scale"

export class HeroPos {

    static group1X = () => Scale.width() * 0.05
    static group1Y = () => Scale.height() * 0.48

    static group1CigX = () => Scale.width() * 0.133
    static group1CigY = () => Scale.height() * 0.515

    static group1SmokeX = () => Scale.width() * 0.133
    static group1SmokeY = () => Scale.height() * 0.515

    static group1BX = () => Scale.width() * 0.17

    static group1BCigX = () => Scale.width() * 0.195
    static group1BCigY = () => Scale.height() * 0.64

    static group1BSmokeX = () => Scale.width() * 0.09
    static group1BSmokeY = () => Scale.height() * 0.59

    static group2X = () => Scale.width() * 0.8
    static group2Y = () => Scale.height() * 0.7

    static group2AshtrayX = () => Scale.width() * 0.87
    static group2AshTrayY = () => Scale.height() * 0.75

    static group2AshtrayCigX = () => Scale.width() * 0.893
    static group2AshTrayCigY = () => Scale.height() * 0.825

    static group2AshtraySmokeX = () => Scale.width() * 0.878
    static group2AshTraySmokeY = () => Scale.height() * 0.745

    static group2CigX = () => Scale.width() * 0.885
    static group2CigY = () => Scale.height() * 0.77

    static group2SmokeX = () => Scale.width() * 0.855
    static group2SmokeY = () => Scale.height() * 0.7

    static group3X = () => Scale.width() * 0.31
    static group3Y = () => Scale.height() * 0.38

    static group3CigX = () => Scale.width() * 0.32
    static group3CigY = () => Scale.height() * 0.47

    static group3SmokeX = () => Scale.width() * 0.345
    static group3SmokeY = () => Scale.height() * 0.415

    static group4X = () => Scale.width() * 0.435
    static group4Y = () => Scale.height() * 0.21

    static group4CigX = () => Scale.width() * 0.45
    static group4CigY = () => Scale.height() * 0.32

    static group4SmokeX = () => Scale.width() * 0.435
    static group4SmokeY = () => Scale.height() * 0.26

    static group5X = () => Scale.width() * 0.2
    static group5Y = () => Scale.height() * 0.15

    static group5SmokeX = () => Scale.width() * 0.16
    static group5SmokeY = () => Scale.height() * 0.18

    static group5CigX = () => Scale.width() * 0.27
    static group5CigY = () => Scale.height() * 0.17

    static kidX = () => Scale.width() * 0.58
    static kidY = () => Scale.height() * 0.53

    static babyX = () => Scale.width() * 0.82
    static babyY = () => Scale.height() * 0.55

    static twoKidsX = () => Scale.width() * 0.7
    static twoKidsY = () => Scale.height() * 0.38

    static dogX = () => Scale.width() * 0.635
    static dogY = () => Scale.height() * 0.475

    static womanX = () => Scale.width() * 0.87
    static womanY = () => Scale.height() * 0.4

    static womanCigX = () => Scale.width() * 0.86
    static womanCigY = () => Scale.height() * 0.44

    static womanSmokeX = () => Scale.width() * 0.84
    static womanSmokeY = () => Scale.height() * 0.375

    static ashtrayX = () => Scale.width() * 0.85
    static ashtrayY = () => Scale.height() * 0.295

    static ashtrayCigX = () => Scale.width() * 0.873
    static ashtrayCigY = () => Scale.height() * 0.37

    static ashtraySmokeX = () => Scale.width() * 0.858
    static ashtraySmokeY = () => Scale.height() * 0.29

    static trashcanX = () => Scale.width() * 0.01
    static trashcanY = () => Scale.height() * 0.73

    static trashcanTextX = () => Scale.width() * 0.105
    static trashcanTextY = () => Scale.height() * 0.78

    static timeRemainingY = () => Scale.height() * 0.01

    static secondsX = () => Scale.width() * 0.505
    static secondsY = () => Scale.height() * 0.08

    static timeTensOfSecondsX = () => Scale.width() * 0.413
    static timeSecondsX = () => Scale.width() * 0.464
    static timeSecondsY = () => Scale.height() * 0.063


    // ***** DIFFICULTY SETTINGS POSITIONS BELOW HERE ***** //

    static easyButtonX = () => Scale.width() * 0.15
    static mediumButtonX = () => Scale.width() * 0.4
    static hardButtonX = () => Scale.width() * 0.65
    static buttonY = () => Scale.height() * 0.83

    static directionsY = () => Scale.height() * 0.4
    static scorePanelY = () => Scale.height() * 0.38
    static scoresX = () => Scale.width() * 0.315
    static scoresY = () => Scale.height() * 0.42

    static titleY = () => Scale.height() * 0.22

}
